/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de articulos.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
*      2       | 17/07/2026 | Lic. Jose Luis Aragon Cervantes  | Ajuste de formulario de articulos para captura portatil
*      3       | 17/07/2026 | Lic. Jose Luis Aragon Cervantes  | Mejora responsiva de cabecero y formulas en articulos
*      4       | 19/07/2026 | Lic. Jose Luis Aragon Cervantes  | Banner fijo con ajuste ante teclado en articulos
* ---------------------------------------------------------------------------------------
*/

import { useEffect, useRef } from "react";
import FrmArticulos from "../../../catalogos/articulos/Articulos.jsx";
import SizeSoftXFrmPortatil from "../../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmArticulosPortatil() {
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;

    let focusTimer;

    const syncKeyboardOffset = () => {
      const viewport = window.visualViewport;
      const offset = viewport
        ? Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop)
        : 0;

      root.style.setProperty("--articulos-keyboard-offset", `${Math.round(offset)}px`);
    };

    const handleFocusIn = (event) => {
      const target = event.target;
      if (!target?.closest || !target.closest(".medidasCostosCombos")) return;

      syncKeyboardOffset();
      window.clearTimeout(focusTimer);
      focusTimer = window.setTimeout(() => {
        target.scrollIntoView({ block: "center", inline: "nearest", behavior: "smooth" });
      }, 180);
    };

    const viewport = window.visualViewport;
    viewport?.addEventListener("resize", syncKeyboardOffset);
    viewport?.addEventListener("scroll", syncKeyboardOffset);
    root.addEventListener("focusin", handleFocusIn);
    syncKeyboardOffset();

    return () => {
      window.clearTimeout(focusTimer);
      viewport?.removeEventListener("resize", syncKeyboardOffset);
      viewport?.removeEventListener("scroll", syncKeyboardOffset);
      root.removeEventListener("focusin", handleFocusIn);
    };
  }, []);

  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmArticulos">
      <div ref={rootRef} className="articulos-portatil">
        <FrmArticulos />
      </div>
    </SizeSoftXFrmPortatil>
  );
}
